// extracted by mini-css-extract-plugin
export default {"file":"File-module__file__Ni1Hm","invalid":"File-module__invalid__e7t6A"};